import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  sidebarExpanded: boolean;
  actions: {
    toggleSidebar: () => void;
  };
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarExpanded: true,
      actions: {
        toggleSidebar: () => set((state) => ({ sidebarExpanded: !state.sidebarExpanded })),
      },
    }),
    {
      name: 'DATSIM/UI',
      version: 1,
      partialize: ({ actions, ...rest }) => rest,
    },
  ),
);
